/**
 * Created by fwt on 2019/8/2.
 */
import React,{Component} from "react"
import {NavBar, Toast} from 'antd-mobile';
import {discountInfo,} from '../../../../service/memberService';
import './style.less';
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo})
)
export default class DiscountsInfo extends Component{
    constructor(props) {
        super(props);
        this.state={
            data:"",
        }
    }

    componentDidMount() {
        let params = {
            source:1,
            token:this.props.userInfo.token,
            data:{couponId:this.props.match.params.id}
        };
        discountInfo(params).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({data:res.data.data})
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    render() {
        const {data}=this.state;
        return (
            <div className="discountsInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() =>this.props.history.goBack()}/>}
                >优惠券详情</NavBar>
                <div className="content">
                    <div className="unused">
                        <div className="left">
                            {data.couponType ? data.couponType == 1 ? <p className="pic">￥<span>{parseFloat(data.couponAmount).toFixed(2)}</span></p> : <p className="pic"><span>{data.couponRatio * 10}</span>折</p> : null}
                            {data.limitType ? data.limitType == 1 ? <p>无限制</p> :<p>满{parseInt(data.useLimitAmount)}可用</p> : null}
                        </div>
                        <div className="right">
                            <p className="title">{data.couponName}</p>
                            <p className="time">有效期：{data.allotTime}</p>
                        </div>
                    </div>
                    <div className="info">
                        <div className="tit">使用明细</div>
                        <div className="textBox">
                            <p className="typeName">有效期限：</p>
                            <div>{data.allotTime}</div>
                            <p className="typeName">使用条件：</p>
                            <div>购买预约出行座位价格满{data.useLimitAmount}元可使用，{data.couponType == 1 ? "最多抵扣票价50%，" :null}仅可使用一次。</div>
                            <p className="typeName">订单类型：</p>
                            <div>{data.couponOrderType == 0 ? "预约出行" :"城内"}</div>
                            <p className="typeName">可用线路：</p>
                            <div>{data.orderId && data.orderId.map((res)=>{
                                return res+","
                            })}</div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/Discounts/DiscountsInfo/index.js